import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=fdcf93ca&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdcf93ca')) {
      api.createRecord('fdcf93ca', component.options)
    } else {
      api.reload('fdcf93ca', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=fdcf93ca&", function () {
      api.rerender('fdcf93ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mIF5o0tAselg/JS/offershelp.vue"
export default component.exports